export const UserAvatarSizes = Object.freeze({
  Small: "sm",
  Medium: "md",
  Large: "lg",
} as const);

export type UserAvatarSize =
  (typeof UserAvatarSizes)[keyof typeof UserAvatarSizes];

export const UserAvatarSizeOptions: UserAvatarSize[] =
  Object.values(UserAvatarSizes);
